import { useCallback, useMemo } from "react"

import { type UseQueryOptions, type UseQueryResult, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { ServerStateKeys as EQueryKey } from "@/constants"

import { type TSubUserListQueryUtils as TUtils, subUserListQueryUtils as utils } from "./utils"

import { type ISubUserDto as IDto, type ISubUserModel as IModel } from "."

const { adaptSubUserList: adapter, fetchSubUserList: fetcher }: TUtils = utils

type TParams = Pick<UseQueryOptions, "enabled">
type TQuery = UseQueryResult<IModel[], AxiosError>

function useHook(params: TParams = {}): ReturnType<(params: TParams) => TQuery> {
    return useQuery<IDto[], AxiosError, IModel[], Array<EQueryKey>>({
        queryKey: useMemo((): [EQueryKey] => [EQueryKey.SubUsers], []),
        queryFn: useCallback(fetcher, []),
        select: useCallback(adapter, []),
        notifyOnChangeProps: ["data", "isSuccess"],
        ...params
    })
}

export { useHook as useSubUserListQuery, type TQuery as TSubUserListQuery }
